import React from "react";
import { Reveal, SectionHeading } from "./_shared";
import { motion } from "framer-motion";
import { Bot, FileText } from "lucide-react";

const benefits = [
    "Chatbot e agente AI integrato",
    "Registri completamente digitalizzati",
    "Controllo immediato delle scadenze",
    "Documenti e dossier aziendali",
    "Consultazione con intelligenza artificiale",
    "Aziende, sedi e lavoratori organizzati",
    "Monitoraggio della formazione",
    "Sorveglianza sanitaria e sopralluoghi",
    "Report e panoramiche operative",
];

export default function Platform() {
    return (
        <section id="piattaforma" className="relative py-24 md:py-32 bg-navy-50">
            <div aria-hidden className="absolute inset-0 bg-grid-light opacity-40 pointer-events-none" />
            <div className="max-w-[1400px] mx-auto px-5 md:px-8 relative">
                <div className="grid lg:grid-cols-2 gap-16 items-start">
                    <div>
                        <SectionHeading
                            chapter={2}
                            chapterLabel="La piattaforma"
                            title={
                                <>
                                    Il software gestionale per la sicurezza sul lavoro,{" "}
                                    <span className="italic font-medium text-navy-500">potenziato dall'intelligenza artificiale.</span>
                                </>
                            }
                        />
                        <Reveal delay={0.15}>
                            <p className="mt-6 text-navy-700 text-lg leading-relaxed max-w-xl">
                                SafetyDesk81 è il <strong className="text-navy-950">software HSE</strong> di{" "}
                                <strong className="text-navy-950">Centro Sicurezza Consulenze</strong>: un gestionale
                                per la sicurezza sul lavoro che centralizza scadenze, formazione (compresa la
                                formazione alimentaristi), sorveglianza sanitaria, sopralluoghi, documenti e registri.
                                L'intelligenza artificiale rende più semplice la consultazione: puoi{" "}
                                <strong className="text-navy-950">interrogare la piattaforma</strong> tramite chatbot o
                                agente AI e ridurre l'utilizzo della carta.
                            </p>
                        </Reveal>
                        <Reveal delay={0.22}>
                            <div className="mt-8 grid sm:grid-cols-2 gap-3 max-w-xl">
                                <HighlightCard
                                    icon={<Bot size={22} />}
                                    title="Consulenza agentica"
                                    desc="Un agente AI che consulta scadenze, documenti e adempimenti al posto tuo."
                                />
                                <HighlightCard
                                    icon={<FileText size={22} />}
                                    title="Registri digitali"
                                    desc="Compila, firma e conserva registri, dossier e documenti senza carta."
                                />
                            </div>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <div className="mt-8 flex items-center gap-3 text-sm text-navy-600">
                                <div className="flex -space-x-2">
                                    {["#FFCB05", "#012659", "#1B4CE0"].map((c, i) => (
                                        <div key={i} className="w-8 h-8 rounded-full border-2 border-navy-50" style={{ background: c }} />
                                    ))}
                                </div>
                                <span>
                                    Realizzata da chi la sicurezza sul lavoro <br className="hidden md:block" />
                                    la vive e la applica ogni giorno.
                                </span>
                            </div>
                        </Reveal>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {benefits.map((b, i) => {
                            const highlighted = i < 2;
                            return (
                                <motion.div
                                    key={b}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, amount: 0.4 }}
                                    transition={{ duration: 0.5, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
                                    data-testid={`platform-benefit-${i}`}
                                    className={`group flex items-start gap-3 p-4 rounded-2xl border hover-lift ${
                                        highlighted
                                            ? "bg-navy-950 text-white border-navy-950"
                                            : "bg-white border-navy-100 text-navy-950"
                                    }`}
                                >
                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 font-bold ${highlighted ? "bg-gold-400 text-navy-950" : "bg-gold-400 text-navy-950"}`}>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                    </div>
                                    <div className="font-medium leading-tight pt-1">{b}</div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}

function HighlightCard({ icon, title, desc }) {
    return (
        <div className="rounded-2xl bg-white border border-navy-100 p-4 hover-lift">
            <div className="w-10 h-10 rounded-xl bg-gold-100 text-gold-700 flex items-center justify-center mb-3">
                {icon}
            </div>
            <div className="font-display font-bold text-navy-950">{title}</div>
            <div className="text-navy-600 text-sm mt-1 leading-snug">{desc}</div>
        </div>
    );
}
